/**
 * @generated SignedSource<<9ca19c34242b4ea1f948a4d56f70286c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksWaitForSellerExists_checkSellerExistsQuery$variables = Record<PropertyKey, never>;
export type hooksWaitForSellerExists_checkSellerExistsQuery$data = {
  readonly existsCurrentSellerOnIntegrationService: boolean;
  readonly existsCurrentSellerOnMarketingService: boolean;
  readonly existsCurrentSellerOnMarketplaceIntegrationService: boolean;
  readonly existsCurrentSellerOnOrderService: boolean;
  readonly existsCurrentSellerOnSalesChannelService: boolean;
  readonly existsCurrentSellerOnSubscriptionService: boolean;
};
export type hooksWaitForSellerExists_checkSellerExistsQuery = {
  response: hooksWaitForSellerExists_checkSellerExistsQuery$data;
  variables: hooksWaitForSellerExists_checkSellerExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnSubscriptionService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnIntegrationService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnSalesChannelService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnMarketplaceIntegrationService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnMarketingService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnOrderService",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "346d0558e24366d8923541a7c88421db",
    "id": null,
    "metadata": {},
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "operationKind": "query",
    "text": "query hooksWaitForSellerExists_checkSellerExistsQuery {\n  existsCurrentSellerOnSubscriptionService\n  existsCurrentSellerOnIntegrationService\n  existsCurrentSellerOnSalesChannelService\n  existsCurrentSellerOnMarketplaceIntegrationService\n  existsCurrentSellerOnMarketingService\n  existsCurrentSellerOnOrderService\n}\n"
  }
};
})();

(node as any).hash = "0f121e9e2704a5f8e083d8f07686a716";

export default node;
